import type { AeTemplateStatus } from '@/types/assessmentEngine';

/** Status options shown in the list dropdown (current + allowed transitions; never back to draft). */
export function templateStatusOptions(current: AeTemplateStatus): AeTemplateStatus[] {
  switch (current) {
    case 'draft':
      return ['draft', 'published'];
    case 'published':
      return ['published', 'retired'];
    case 'retired':
      return ['retired', 'published'];
    default:
      return [current];
  }
}

export type TemplateStatusTransition = 'publish' | 'retire' | 'republish';

export function resolveTemplateStatusTransition(
  from: AeTemplateStatus,
  to: AeTemplateStatus
): TemplateStatusTransition | null {
  if (from === to) return null;
  if (from === 'draft' && to === 'published') return 'publish';
  if (from === 'published' && to === 'retired') return 'retire';
  if (from === 'retired' && to === 'published') return 'republish';
  return null;
}
